import React from "react";

const HTMLToComponent = ({ htmlString }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export default HTMLToComponent;
